import { render, staticRenderFns } from "./burgerMenu.vue?vue&type=template&id=131d2e5c&scoped=true&"
import script from "./burgerMenu.vue?vue&type=script&lang=js&"
export * from "./burgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./burgerMenu.vue?vue&type=style&index=0&id=131d2e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131d2e5c",
  null
  
)

export default component.exports